import { useDebouncedValue } from '@txt/core.utils/hooks';
import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { useLoadData } from './useLoadData';

type Options = {
  debounceRate: number;
  skip?: boolean;
  customLoadingCmp?: React.ReactElement;
};

export function useLoadDataDebounced<T>(
  loadData: (prevData: T | null) => Promise<T>,
  loadParams: Array<unknown> = [],
  options: Options,
) {
  const { skip, debounceRate, customLoadingCmp } = options;
  const stableLoadParam = React.useMemo(() => loadParams, [...loadParams]);
  const debouncedLoadParams = useDebouncedValue(stableLoadParam, debounceRate);

  const [data, loadOrErrCmp, helpers] = useLoadData(loadData, debouncedLoadParams, {
    skip,
    customLoadingCmp,
  });
  const isPending = !shallowEqual(loadParams, debouncedLoadParams);

  return Object.assign([data, loadOrErrCmp, { ...helpers, isPending }] as const, {
    data,
    loadOrErrCmp,
    ...helpers,
    isPending,
  });
}
